module.exports = __webpack_public_path__ + "img/c.ba13985e.png";